import React from 'react';

// Lean base classes; visuals are controlled by theme classes in index.css
const baseClasses = 'inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50';

// Map semantic variants to our theme classes (index.css)
const variants = {
  default: 'button-outline',         // neutral by default
  outline: 'button-outline',
  ghost: 'btn-ghost',
  primary: 'btn-gold-primary'
};

export const Button = React.forwardRef(function Button(
  { className = '', variant = 'default', type = 'button', ...props },
  ref
) {
  const variantClasses = variants[variant] || variants.default;
  const classes = [baseClasses, variantClasses, className].filter(Boolean).join(' ');
  return <button ref={ref} className={classes} type={type} {...props} />;
});

Button.displayName = 'Button';

export default Button;
